import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-247">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-248">
        <img src="https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?auto=format&fit=crop&q=80&w=2000" alt="Indian woman practicing yoga outdoors" className="w-full h-full object-cover object-center" data-id="element-249" />
        <div className="absolute inset-0 bg-gradient-to-r from-yoga-dark/80 via-yoga-dark/60 to-transparent" data-id="element-250"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-20" data-id="element-251">
        <div className="max-w-2xl" data-id="element-252">
          <FadeIn delay={100} data-id="element-253">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6" data-id="element-254">
              <div className="flex text-yoga-primary" data-id="element-255">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-256" />)}
              </div>
              <span className="text-white text-sm font-medium" data-id="element-257">
                4.9 Rated on Google
              </span>
            </div>
          </FadeIn>

          <FadeIn delay={300} data-id="element-258">
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6" data-id="element-259">
              Find your <span className="text-yoga-primary" data-id="element-260">inner peace</span>{' '}
              in Pune.
            </h1>
          </FadeIn>

          <FadeIn delay={500} data-id="element-261">
            <p className="text-lg md:text-xl text-white/90 mb-10 max-w-xl leading-relaxed" data-id="element-262">
              Join Shree Yoga Fitness to transform your body, calm your mind,
              and elevate your spirit. Expert guidance for all levels in a
              welcoming, serene environment.
            </p>
          </FadeIn>

          <FadeIn delay={700} data-id="element-263">
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-264">
              <a href="#contact" className="bg-yoga-primary text-white px-8 py-4 rounded-full text-center font-bold text-lg hover:bg-yoga-light transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-yoga-primary/30" data-id="element-265">
                Start your journey
              </a>
              <a href="#schedule" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-center font-bold text-lg hover:bg-white hover:text-yoga-dark transition-all" data-id="element-266">
                View schedule
              </a>
            </div>
          </FadeIn>
        </div>
      </div>

      {/* Decorative floating element */}
      <div className="absolute bottom-10 right-10 opacity-20 animate-float hidden lg:block" data-id="element-267">
        <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-268">
          <path d="M100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0ZM100 180C55.8172 180 20 144.183 20 100C20 55.8172 55.8172 20 100 20C144.183 20 180 55.8172 180 100C180 144.183 144.183 180 100 180Z" fill="#fc6803" data-id="element-269" />
          <path d="M100 40C66.8629 40 40 66.8629 40 100C40 133.137 66.8629 160 100 160C133.137 160 160 133.137 160 100C160 66.8629 133.137 40 100 40ZM100 140C77.9086 140 60 122.091 60 100C60 77.9086 77.9086 60 100 60C122.091 60 140 77.9086 140 100C140 122.091 122.091 140 100 140Z" fill="#fc6803" data-id="element-270" />
        </svg>
      </div>
    </section>;
}